import IconBox from '../../../components/common/icon-box'
import AccountLayout from '../../../components/layout/account-layout'
import EditLanguageForm from './edit-language-form'
import { useTranslation } from '../../../useTranslation'
import UpdatePassword from './update-password'
import UpdateEmail from './update-email'
import { CorrespondenceEmails } from './correspondence-emails'
import { Link } from 'react-router-dom'
import Button from '../../../components/common/button'
import { useUser } from '../../../common/hooks/auth/useUser'

const Details = () => {
    const { t } = useTranslation()
    const { user } = useUser()
    return (
        <AccountLayout>
            <div className="grid grid-cols-2 gap-[12px]">
                <div className="w-full mb-8">
                    <IconBox icon={'user'}>
                        <div className="pt-12 pb-6 px-2 max-tablet:pt-10">
                            <p className="font-bold text-xl text-left leading-none max-tablet:text-sm">{t('myAccount.personalData.personalDetails')}</p>
                            <div className="flex flex-col gap-3 pt-4 pb-7 max-tablet:pb-2">
                                <div className="text-base text-left max-tablet:text-sm">
                                    <div className="text-custom_yellow">Name</div>
                                    <div>{user?.masterData?.firstName + ' ' + user?.masterData?.lastName}</div>
                                </div>
                                <div className="text-base text-left max-tablet:text-sm">
                                    <div className="text-custom_yellow">{t('emailAddress')}</div>
                                    <div>{user?.email}</div>
                                </div>
                                <div className="text-base text-left max-tablet:text-sm">
                                    <div className="text-custom_yellow ">{t('customerNumber')}</div>
                                    <div>{user?.customerNumber}</div>
                                </div>
                            </div>
                            <Link to="/account/addresses">
                                <Button type="squareBlue" icon="gear" text={t('myAccount.overview.changePersonalData')} />
                            </Link>
                        </div>
                    </IconBox>
                </div>
                <div className="w-full mb-8">
                    <IconBox icon={'earth-americas'}>
                        <div className="pt-12 pb-6 px-2 max-tablet:pt-10">
                            <p className="font-bold text-xl text-left leading-none max-tablet:text-sm">{t('language')}</p>
                            <EditLanguageForm />
                        </div>
                    </IconBox>
                </div>
                <div className="w-full mb-8">
                    <UpdateEmail />
                </div>
                <div className="w-full mb-8">
                    <UpdatePassword />
                </div>
                <div className="w-full mb-8">
                    <CorrespondenceEmails />
                </div>
            </div>
        </AccountLayout>
    )
}

export default Details
